<template>
  <div class="searchResultInformation">
    <p class="searchResultInformation_result">
      <span class="searchResultInformation_count">
        <span>{{ formatedTotalCount }}</span>
        件
      </span>
      <span class="searchResultInformation_page" v-if="totalCount > 0">
        {{ pageingRange }}
      </span>
    </p>

    <div>
      <InputSelectbox
        :options="sortOptions"
        @selection-change="changeSortOptions"
      />
    </div>
  </div>
</template>

<script lang="ts">
import { computed, SetupContext } from 'vue'
import { numberFormatAddComma } from '@/utils/commonMethods'
import InputSelectbox from '@/components/elements/InputSelectbox.vue'

export default {
  name: 'SearchResultInformation',

  components: {
    InputSelectbox
  },

  props: {
    totalCount: {
      type: Number,
      default: 0
    },
    pageNum: {
      type: Number,
      default: 1
    },
    rowCnt: {
      type: Number,
      default: 15
    }
  },

  setup(props: any, context: SetupContext) {
    const sortOptions = [
      {
        value: '1',
        label: 'おすすめ順',
        selected: false
      },
      {
        value: '2',
        label: '医師数順',
        selected: false
      },
      {
        value: '3',
        label: '病床数順',
        selected: false
      }
    ]

    const formatedTotalCount = computed(() => {
      return numberFormatAddComma(props.totalCount)
    })

    const pageingRange = computed(() => {
      const start = props.pageNum * props.rowCnt - props.rowCnt + 1
      let end = props.pageNum * props.rowCnt

      if (end > props.totalCount) end = props.totalCount

      return `${start}〜${end}件`
    })

    const changeSortOptions = (value: string) => {
      context.emit('change-sort-options', value)
    }

    return {
      sortOptions,
      pageingRange,
      changeSortOptions,
      formatedTotalCount
    }
  }
}
</script>

<style lang="scss" scoped>
@use 'src/styles/abstracts/mixins';
@use 'src/styles/abstracts/variables' as var;

.searchResultInformation {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-right: -7px;

  &_result {
    font-size: 1.4rem;
  }

  &_count {
    margin-right: 10px;

    span {
      font-size: 2.2rem;
    }
  }
}
</style>
